module.exports = __webpack_public_path__ + "media/images/figure/contractor-6d60dc9577c488847e9dfc63029ef8af.gif";